import { CustomerSupportInformationFormType } from 'components/customer-support-information/CustomerSupportInformationForm';

export const updateCustomerSupportInformationInitialValues: Partial<CustomerSupportInformationFormType> = {};
